import { combineReducers } from "redux";
import userReducer from "./userReducer";
import generalReducer from "./generalReducer";

const rootReducer = combineReducers({
  user: userReducer,
  general: generalReducer
});

export default rootReducer;
